import React from 'react';
import { Typography } from '@kareo/design-system';
var HistorySectionHeader = function (_a) {
    var title = _a.title;
    return (React.createElement(Typography, { variant: "h4", component: "div" }, title));
};
export default HistorySectionHeader;
